import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api, formatApiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import Logo from "@/components/Logo";

export default function AuthCallback() {
    const [error, setError] = useState(null);
    const { refresh } = useAuth();
    const navigate = useNavigate();
    const hasProcessed = useRef(false);

    useEffect(() => {
        if (hasProcessed.current) return;
        hasProcessed.current = true;

        (async () => {
            const hash = window.location.hash || "";
            const match = hash.match(/session_id=([^&]+)/);
            if (!match) {
                setError("No session id in URL");
                return;
            }
            const sessionId = decodeURIComponent(match[1]);
            try {
                const { data } = await api.post("/auth/google/session", { session_id: sessionId });
                if (data?.access_token) {
                    localStorage.setItem("srtf_access_token", data.access_token);
                }
                await refresh();
                // Clear hash and navigate
                window.history.replaceState({}, "", window.location.pathname);
                navigate("/marketplace", { replace: true });
            } catch (err) {
                setError(formatApiError(err));
            }
        })();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div className="min-h-screen bg-onyx-900 flex items-center justify-center">
            <div className="flex flex-col items-center gap-4">
                <Logo size="lg" showWordmark={false} />
                {error ? (
                    <div className="text-center max-w-sm">
                        <div className="headline text-2xl">Sign-in failed</div>
                        <div className="text-sm text-onyx-500 mt-2">{error}</div>
                        <button
                            onClick={() => navigate("/login")}
                            className="btn-red mt-4 px-4 py-2 rounded-sm text-sm"
                            data-testid="auth-callback-retry"
                        >
                            Try again
                        </button>
                    </div>
                ) : (
                    <div className="label-caps text-onyx-500">Firing up your Garage...</div>
                )}
            </div>
        </div>
    );
}
